import {
  H_05,
  HERO_DEFAULTS,
  hideH05Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const H05_PLASMIC_PROPS = {
  h05Heading: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_05].heading,
    description: "Main hero heading (H05 only)",
    hidden: hideH05Props,
  },
  h05Description: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_05].description,
    description: "Hero description text (H05 only)",
    hidden: hideH05Props,
  },
  h05PrimaryButtonText: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_05].primaryButtonText,
    description: "Primary button text (H05 only)",
    hidden: hideH05Props,
  },
  h05PrimaryButtonUrl: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_05].primaryButtonUrl,
    description: "Primary button URL (H05 only)",
    hidden: hideH05Props,
  },
  h05SecondaryButtonText: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_05].secondaryButtonText,
    description: "Secondary button text (H05 only)",
    hidden: hideH05Props,
  },
  h05SecondaryButtonUrl: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_05].secondaryButtonUrl,
    description: "Secondary button URL (H05 only)",
    hidden: hideH05Props,
  },
  h05HeroImage: {
    type: "imageUrl",
    defaultValue: HERO_DEFAULTS[H_05].heroImage,
    description: "Hero image (H05 only)",
    hidden: hideH05Props,
  },
  h05HeroImageAlt: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_05].heroImageAlt,
    description: "Hero image alt text (H05 only)",
    hidden: hideH05Props,
  },
  h05BulletPoints: {
    type: "array",
    itemType: {
      type: "object",
      fields: {
        iconImage: {
          type: "imageUrl",
        },
        iconImgAlt: {
          type: "string",
        },
        text: {
          type: "string",
        },
      },
    },
    defaultValue: HERO_DEFAULTS[H_05].bulletPoints,
    description: "Bullet points array (H05 only)",
    hidden: hideH05Props,
  },
  className: {
    type: "string",
    defaultValue: "",
  },
};
